(function () {
  'use strict';

  var UG_PER_IU = 40;

  var COPY = {
    nl: {
      title: 'Vitamine D Check',
      intro: 'Beantwoord vragen over zonlicht, voeding, supplementen en persoonlijke factoren. We combineren alle vier onderdelen tot één persoonlijke vitamine-D-risico-indicatie.',
      accountNote: 'Geen account nodig.',
      backLabel: 'Terug naar MJ Apps',
      sunTitle: 'Zonlicht',
      periodLabel: 'Periode',
      durationLabel: 'Buiten bij daglicht',
      durationQuestion: 'Hoeveel tijd breng je gemiddeld per dag buiten door?',
      durationHint: 'Langer buiten zijn is niet automatisch beter. Bescherm je huid tegen overmatige UV-blootstelling.',
      daytimeLabel: 'Meestal buiten',
      skinareaLabel: 'Blootgestelde huid',
      exposureLabel: 'Soort blootstelling',
      skinLabel: 'Huidtype',
      personalTitle: 'Persoonlijk',
      foodTitle: 'Voeding',
      fishLabel: 'Hoe vaak eet je vette vis?',
      fishHint: 'Bijv. zalm, haring, makreel, sardines of forel.',
      eggsLabel: 'Hoe vaak eet je eieren?',
      fortifiedLabel: 'Gebruik je producten verrijkt met vitamine D?',
      fortifiedHint: 'Bijv. verrijkte margarine, zuivel, plantaardige drinks en ontbijtproducten.',
      mushroomsLabel: 'Andere vitamine-D-rijke voeding?',
      mushroomsHint: 'Bijv. champignons die met UV-licht zijn behandeld.',
      suppTitle: 'Supplementen',
      suppUseLabel: 'Gebruik je vitamine D als supplement?',
      doseLabel: 'Hoeveel vitamine D per dag?',
      doseHint: '1 µg vitamine D = 40 IE.',
      ageLabel: 'Leeftijd',
      absorptionLabel: 'Heb je een aandoening of operatie die vet-/voedingsstofopname kan verminderen?',
      pregLabel: 'Zwanger of borstvoeding?',
      calculateBtn: 'Analyseer mijn vitamine D-profiel',
      resultTitle: 'Jouw vitamine D-profiel',
      resultEmpty: 'Beantwoord de vragen. De uitslag volgt je antwoorden en combineert zon, voeding, supplementen en persoonlijke factoren.',
      whyTitle: 'Waarom deze uitslag?',
      positiveTitle: 'Wat werkt in je voordeel?',
      intakeTitle: 'Belgische richtlijn',
      specialTitle: 'Extra aandacht',
      bloodText: 'Deze check stelt geen vitamine-D-tekort vast. Een 25(OH)D-bloedtest blijft de beste manier om je werkelijke vitamine-D-status te beoordelen.',
      methodText: 'De MUSKLE-score is een leefstijl-risico-indicatie en geen gevalideerd klinisch voorspelmodel.',
      sourceNote: 'Bronnen voor de inhoud: Sciensano / Belgische Hoge Gezondheidsraad en NIH Office of Dietary Supplements. Bij medische aandoeningen, zwangerschap, medicatiegebruik, bariatrische chirurgie of twijfel: bespreek vitamine D met arts of apotheker.',
      riskLow: 'Lagere risico-indicatie',
      riskMid: 'Verhoogde risico-indicatie',
      riskHigh: 'Sterk verhoogde risico-indicatie',
      intakeAdult: 'Totale aanbevolen inname (Hoge Gezondheidsraad), 11–70 jaar: 10–15 µg per dag. Het aparte suppletieadvies van Sciensano voor volwassenen is vaak 10 µg per dag.',
      intake70: 'Totale aanbevolen inname (Hoge Gezondheidsraad) vanaf 70 jaar: 20 µg per dag. Sciensano adviseert voor ouderen ook een supplement van 20 µg per dag.',
      intakePreg: 'Totale aanbevolen inname (Hoge Gezondheidsraad) bij zwangerschap en borstvoeding: 20 µg per dag. Sciensano adviseert dan ook een supplement van 20 µg per dag.',
      specialAbs: 'Je gaf aan dat opname van voedingsstoffen mogelijk verminderd is, bijvoorbeeld na een bariatrische ingreep of bij een spijsverteringsaandoening. Een leefstijlscore is dan minder betrouwbaar. Bespreek dit met arts of apotheker.',
      specialPreg: 'Bij zwangerschap of borstvoeding gelden hogere vitamine-D-aanbevelingen. Gebruik deze check alleen als aanvullende leefstijlinformatie, niet als vervanging van prenatale zorg.',
      specialBoth: 'Je gaf zowel zwangerschap/borstvoeding als mogelijke verminderde opname aan. Bespreek je vitamine-D-inname met arts of apotheker.',
      emptyRisk: 'Er zijn weinig duidelijke leefstijl-risicofactoren aangegeven.',
      emptyPositive: 'Er zijn weinig beschermende leefstijlfactoren aangegeven.',
      doseLine: 'Je gaf {ug} µg per dag op. Dat is {iu} IE. 1 µg vitamine D = 40 IE.',
      sideTitle: 'Je persoonlijke rapport',
      sideText: 'Vul de vragen in en klik op analyseren. Je rapport opent daarna als een apart overzicht, afgestemd op jouw antwoorden.',
      reportKicker: 'Persoonlijk rapport',
      reportTitle: 'Jouw persoonlijke vitamine D-profiel',
      componentsTitle: 'Wat weegt het zwaarst?',
      nextTitle: 'Wat kun je nu doen?',
      relevantTitle: 'Voor jou relevant',
      foodLabel: 'Voeding.',
      suppLabel: 'Supplement.',
      guideLabel: 'Belgische richtlijn.',
      closeLabel: 'Sluiten',
      refillLabel: 'Opnieuw invullen',
      prevLabel: 'Vorige',
      nextLabel: 'Volgende',
      progress: '{n} van 4 · {name}',
      step1Title: 'Zonlicht',
      step1Text: 'Seizoen, tijd buiten en of het licht direct of via glas komt, bepalen mee hoeveel UVB je huid kan gebruiken. Glas houdt UVB tegen.',
      step2Title: 'Voeding',
      step2Text: 'Vette vis en verrijkte voeding wegen hier zwaar mee. Eieren leveren een kleinere hoeveelheid.',
      step3Title: 'Supplement',
      step3Text: 'Een supplement kan een periode met weinig zon deels opvangen. De dosis telt mee, niet alleen ja of nee.',
      step4Title: 'Persoonlijk',
      step4Text: 'Leeftijd, opname en zwangerschap bepalen welke Belgische richtlijn voor jou het meest relevant is.',
      pillarsTitle: 'Jouw vitamine-D-profiel wordt opgebouwd uit 4 onderdelen',
      pillarSupp: 'Supplementen',
      pillarPersonal: 'Persoonlijke factoren',
      comboText: 'Je uitslag is gebaseerd op de combinatie van zonlicht, voeding, supplementen en persoonlijke factoren — niet op één antwoord.',
      weightSun: 'Zonlicht',
      weightFood: 'Voeding',
      weightSupp: 'Supplement',
      weightPersonal: 'Persoonlijke factoren',
      summaryLow: 'Je antwoorden wijzen op relatief weinig factoren die je vitamine-D-status verlagen.',
      summaryMid: 'Je antwoorden wijzen op enkele factoren die je vitamine-D-status kunnen verlagen.',
      summaryHigh: 'Je antwoorden wijzen op meerdere factoren die je vitamine-D-status kunnen verlagen.',
      summaryBecause: 'Vooral {bits} spelen hierbij mee.',
      summaryBecauseOne: 'Vooral {bits} speelt hierbij mee.',
      bitSeasonLow: 'weinig bruikbaar zonlicht in deze periode in België',
      bitSeasonLimited: 'een beperkte UVB-periode in België',
      bitOutside: 'weinig tijd buiten bij daglicht',
      bitDarkSun: 'een donkere huid in combinatie met weinig bruikbaar zonlicht',
      bitGlass: 'buitenlicht dat vaak achter glas valt',
      bitHands: 'blootstelling van vooral gezicht en handen',
      bitFish: 'beperkte inname van vette vis',
      bitSupp: 'het ontbreken van een vitamine-D-supplement',
      bitAge: 'extra aandacht vanaf 70 jaar',
      stepSunWarm: 'In de lichtere maanden kan regelmatige buitenblootstelling bijdragen aan vitamine-D-aanmaak. Langere zonblootstelling is niet automatisch beter; bescherm je huid tegen overmatige UV-blootstelling.',
      stepSunCold: 'In deze periode maakt de huid in België weinig vitamine D aan. Voeding en een supplement vangen dat meer op dan langer buiten blijven.',
      stepGlass: 'Direct buitenlicht telt mee. Glas, ook een autoraam, houdt vrijwel alle UVB tegen.',
      stepArea: 'Alleen gezicht en handen geeft minder aanmaak. Dat is geen reden om langer in de zon te gaan; voeding of een supplement vult dat aan.',
      stepFish: 'Eet vaker vette vis, bijvoorbeeld zalm, haring, makreel of sardines.',
      stepEggs: 'Eieren leveren een kleine hoeveelheid vitamine D en kunnen je voeding aanvullen.',
      stepFortified: 'Kijk of margarine, zuivel of ontbijtproducten die je gebruikt vitamine D bevatten.',
      stepSupp: 'De totale inname voor 11–70 jaar is 10–15 µg per dag. Een supplement is iets anders: Sciensano noemt voor volwassenen vaak 10 µg per dag.',
      stepSuppHigh: 'Vanaf 70 jaar en bij zwangerschap of borstvoeding is de totale inname 20 µg per dag. Sciensano noemt dan ook een supplement van 20 µg per dag.',
      stepMedical: 'Bij verminderde opname is alleen je leefstijl aanpassen niet genoeg. Laat je vitamine-D-inname opvolgen door arts of apotheker.',
      stepPreg: 'Tijdens zwangerschap of borstvoeding is de Belgische aanbeveling 20 µg (800 IE) per dag. Gebruik dit naast prenatale zorg.',
      stepKeep: 'Houd je huidige mix van buiten komen, voeding en supplement aan. Een bloedtest blijft de enige manier om je status te kennen.',
      foodGood: 'Je voeding bevat al meerdere bronnen, zoals vette vis, eieren of verrijkte producten.',
      foodGap: 'Je voeding levert nu weinig vitamine D via vette vis, eieren of verrijkte producten.',
      foodMixed: 'Een deel van je voeding helpt al. Vul vooral de bronnen aan die je nu weinig gebruikt.',
      suppNoneNote: 'Je gebruikt nu geen vitamine-D-supplement.',
      suppGoodNote: 'Je gebruikt dagelijks een relevante hoeveelheid: {ug} µg ({iu} IE).',
      suppLowNote: 'Je supplement is onregelmatig of levert relatief weinig: {ug} µg ({iu} IE) per dag.',
      leadSunRisk: 'Zonlicht weegt het zwaarst in deze uitslag.',
      leadFoodRisk: 'Voeding weegt het zwaarst in deze uitslag.',
      leadSuppRisk: 'Je supplement weegt het zwaarst in deze uitslag.',
      leadPersonalRisk: 'Persoonlijke factoren wegen het zwaarst in deze uitslag.',
      leadSunHelp: 'Zonlicht weegt het zwaarst in je voordeel.',
      leadFoodHelp: 'Voeding weegt het zwaarst in je voordeel.',
      leadSuppHelp: 'Je supplement weegt het zwaarst in je voordeel.',
      sunStrong: 'Duidelijke kans op aanmaak via de huid.',
      sunMid: 'Je komt buiten, maar de omstandigheden beperken de aanmaak.',
      sunLow: 'Weinig bruikbaar UVB in je antwoorden.',
      foodStrongLine: 'Duidelijke bijdrage uit vis, eieren of verrijkte producten.',
      foodMidLine: 'Een deel van je voeding helpt.',
      foodLowLine: 'Weinig vitamine D uit voeding.',
      suppStrongLine: 'Je dagelijkse dosis dekt een relevant deel.',
      suppMidLine: 'Onregelmatig, of een lagere hoeveelheid.',
      suppLowLine: 'Geen relevant supplement aangegeven.',
      personalNone: 'Geen extra leeftijd- of opnamefactor.',
      personalAge70: 'Vanaf 70 jaar vraagt vitamine D extra aandacht.',
      personalAge50: 'Leeftijd kan de aanmaak via de huid wat verminderen.',
      personalAbs: 'Mogelijke verminderde opname weegt extra mee.',
      personalPreg: 'Zwangerschap of borstvoeding vraagt een hogere inname.',
      personalBoth: 'Zwangerschap of borstvoeding én mogelijke verminderde opname wegen extra mee.',
      factors: {
        periodLow: 'In deze periode is er in België weinig UVB voor vitamine-D-aanmaak.',
        periodShoulder: 'In deze periode is het bruikbare UVB-moment in België beperkt.',
        durationNone: 'Je komt bijna nooit buiten bij daglicht.',
        durationLow: 'Je dagelijkse buitenmoment is kort.',
        timeOff: 'Je komt vooral buiten vóór 10:00 of na 17:00, wanneer er minder UVB is.',
        areaLow: 'Alleen gezicht en handen zijn blootgesteld.',
        glass: 'Glas houdt vrijwel alle UVB tegen, ook in de auto.',
        mixed: 'Een deel van je buitenlicht valt achter glas.',
        skinDark: 'Een donkere huid maakt bij dezelfde zonblootstelling minder vitamine D aan.',
        skinMedium: 'Je huidtype kan iets meer zonblootstelling nodig hebben.',
        fishNone: 'Je eet geen vette vis.',
        fishLow: 'Je eet weinig vette vis.',
        fishOne: 'Je eet ongeveer 1× per week vette vis.',
        eggsLow: 'Je eet weinig of geen eieren.',
        fortifiedNone: 'Je gebruikt weinig of geen vitamine-D-verrijkte producten.',
        suppNone: 'Je gebruikt geen vitamine-D-supplement.',
        suppLow: 'Je supplement levert relatief weinig vitamine D of wordt onregelmatig gebruikt.',
        age70: 'Vanaf 70 jaar neemt de vitamine-D-aanmaak in de huid af.',
        age50: 'Leeftijd kan de aanmaak via de huid geleidelijk verminderen.',
        absorption: 'Mogelijke verminderde opname verhoogt de kans op een lage status.'
      },
      positives: {
        periodHigh: 'In deze periode is er in België meer kans op vitamine-D-aanmaak via zonlicht.',
        durationGood: 'Je komt lang genoeg buiten om de aanmaak te laten meetellen.',
        timeGood: 'Je bent buiten rond het sterkste UVB-moment van de dag.',
        areaGood: 'Een groter huidoppervlak is blootgesteld dan alleen gezicht en handen.',
        direct: 'Je krijgt direct buitenlicht, niet alleen achter glas.',
        skinLight: 'Je huid maakt relatief efficiënt vitamine D aan bij UVB-blootstelling.',
        plateau: 'Extra uren boven ongeveer twee uur per dag voegen weinig extra aanmaak toe.',
        fish: 'Je eet regelmatig vette vis.',
        eggs: 'Je eet regelmatig eieren.',
        fortified: 'Je gebruikt regelmatig vitamine-D-verrijkte voeding.',
        suppGood: 'Je gebruikt een relevante hoeveelheid vitamine D.',
        noAbs: 'Je gaf geen bekende opnameproblemen aan.'
      }
    },
    en: {
      title: 'Vitamin D Check',
      intro: 'Answer questions about sunlight, food, supplements and personal factors. We combine all four parts into one personal vitamin D risk indication.',
      accountNote: 'No account needed.',
      backLabel: 'Back to MJ Apps',
      sunTitle: 'Sunlight',
      periodLabel: 'Period',
      durationLabel: 'Outdoors in daylight',
      durationQuestion: 'How much time do you spend outside on an average day?',
      durationHint: 'Staying outside longer is not automatically better. Protect your skin from excessive UV exposure.',
      daytimeLabel: 'Usually outside',
      skinareaLabel: 'Exposed skin',
      exposureLabel: 'Type of exposure',
      skinLabel: 'Skin type',
      personalTitle: 'Personal',
      foodTitle: 'Food',
      fishLabel: 'How often do you eat fatty fish?',
      fishHint: 'For example salmon, herring, mackerel, sardines or trout.',
      eggsLabel: 'How often do you eat eggs?',
      fortifiedLabel: 'Do you use foods fortified with vitamin D?',
      fortifiedHint: 'For example fortified margarine, dairy, plant drinks and breakfast foods.',
      mushroomsLabel: 'Other vitamin-D-rich foods?',
      mushroomsHint: 'For example mushrooms treated with UV light.',
      suppTitle: 'Supplements',
      suppUseLabel: 'Do you take a vitamin D supplement?',
      doseLabel: 'How much vitamin D per day?',
      doseHint: '1 µg vitamin D = 40 IU.',
      ageLabel: 'Age',
      absorptionLabel: 'Do you have a condition or surgery that can reduce fat or nutrient absorption?',
      pregLabel: 'Pregnant or breastfeeding?',
      calculateBtn: 'Analyse my vitamin D profile',
      resultTitle: 'Your vitamin D profile',
      resultEmpty: 'Answer the questions. The result follows your answers and combines sun, food, supplements and personal factors.',
      whyTitle: 'Why this result?',
      positiveTitle: 'What works in your favour?',
      intakeTitle: 'Belgian guidance',
      specialTitle: 'Extra attention',
      bloodText: 'This check does not diagnose a vitamin D deficiency. A 25(OH)D blood test remains the best way to assess your actual vitamin D status.',
      methodText: 'The MUSKLE score is a lifestyle risk indication and not a validated clinical prediction model.',
      sourceNote: 'Content sources: Sciensano / Belgian Superior Health Council and NIH Office of Dietary Supplements. For medical conditions, pregnancy, medicines, bariatric surgery or doubt, discuss vitamin D with a doctor or pharmacist.',
      riskLow: 'Lower risk indication',
      riskMid: 'Increased risk indication',
      riskHigh: 'Strongly increased risk indication',
      intakeAdult: 'Total recommended intake (Superior Health Council), ages 11–70: 10–15 µg per day. Sciensano’s separate supplementation advice for adults is often 10 µg per day.',
      intake70: 'Total recommended intake (Superior Health Council) from age 70: 20 µg per day. Sciensano also advises a 20 µg daily supplement for older adults.',
      intakePreg: 'Total recommended intake (Superior Health Council) in pregnancy and breastfeeding: 20 µg per day. Sciensano also advises a 20 µg daily supplement then.',
      specialAbs: 'You indicated possible reduced nutrient absorption, for example after bariatric surgery or with a digestive condition. A lifestyle score is less reliable in that situation. Discuss this with a doctor or pharmacist.',
      specialPreg: 'Pregnancy or breastfeeding has a higher vitamin D recommendation. Use this check only as extra lifestyle information, not as a replacement for prenatal care.',
      specialBoth: 'You indicated both pregnancy or breastfeeding and possible reduced absorption. Discuss vitamin D intake with a doctor or pharmacist.',
      emptyRisk: 'Few clear lifestyle risk factors were reported.',
      emptyPositive: 'Few protective lifestyle factors were reported.',
      doseLine: 'You entered {ug} µg per day. That is {iu} IU. 1 µg vitamin D = 40 IU.',
      sideTitle: 'Your personal report',
      sideText: 'Answer the questions and click analyse. Your report then opens as a separate overview, based on your answers.',
      reportKicker: 'Personal report',
      reportTitle: 'Your personal vitamin D profile',
      componentsTitle: 'What weighs most?',
      nextTitle: 'What you can do now',
      relevantTitle: 'Relevant for you',
      foodLabel: 'Food.',
      suppLabel: 'Supplement.',
      guideLabel: 'Belgian guidance.',
      closeLabel: 'Close',
      refillLabel: 'Fill in again',
      prevLabel: 'Back',
      nextLabel: 'Next',
      progress: '{n} of 4 · {name}',
      step1Title: 'Sunlight',
      step1Text: 'Season, time outdoors and whether the light is direct or through glass affect how much UVB your skin can use. Glass blocks UVB.',
      step2Title: 'Food',
      step2Text: 'Fatty fish and fortified foods weigh heavily here. Eggs provide a smaller amount.',
      step3Title: 'Supplement',
      step3Text: 'A supplement can partly cover a period with little sun. The dose counts, not only yes or no.',
      step4Title: 'Personal',
      step4Text: 'Age, absorption and pregnancy decide which Belgian guidance is most relevant for you.',
      pillarsTitle: 'Your vitamin D profile is built from 4 parts',
      pillarSupp: 'Supplements',
      pillarPersonal: 'Personal factors',
      comboText: 'Your result is based on the combination of sunlight, food, supplements and personal factors — not on one answer.',
      weightSun: 'Sunlight',
      weightFood: 'Food',
      weightSupp: 'Supplement',
      weightPersonal: 'Personal factors',
      summaryLow: 'Your answers point to relatively few factors that can lower vitamin D status.',
      summaryMid: 'Your answers point to some factors that can lower vitamin D status.',
      summaryHigh: 'Your answers point to several factors that can lower vitamin D status.',
      summaryBecause: 'In particular, {bits} play a role.',
      summaryBecauseOne: 'In particular, {bits} plays a role.',
      bitSeasonLow: 'little useful sunlight in Belgium during this period',
      bitSeasonLimited: 'a limited UVB window in Belgium',
      bitOutside: 'little time outdoors in daylight',
      bitDarkSun: 'darker skin combined with little useful sunlight',
      bitGlass: 'daylight that often comes through glass',
      bitHands: 'exposure of mainly the face and hands',
      bitFish: 'limited fatty fish intake',
      bitSupp: 'not using a vitamin D supplement',
      bitAge: 'extra attention from age 70',
      stepSunWarm: 'In the lighter months, regular time outdoors can contribute to vitamin D production. Longer sun exposure is not automatically better; protect your skin from excessive UV exposure.',
      stepSunCold: 'In this period the skin makes little vitamin D in Belgium. Food and a supplement cover that better than staying outside longer.',
      stepGlass: 'Direct outdoor light counts. Glass, including a car window, blocks almost all UVB.',
      stepArea: 'Face and hands only means less production. That is not a reason to stay in the sun longer; food or a supplement can fill the gap.',
      stepFish: 'Eat fatty fish more often, for example salmon, herring, mackerel or sardines.',
      stepEggs: 'Eggs provide a small amount of vitamin D and can complement your diet.',
      stepFortified: 'Check whether the margarine, dairy or breakfast products you use contain vitamin D.',
      stepSupp: 'Total intake for ages 11–70 is 10–15 µg per day. A supplement is separate: Sciensano often cites 10 µg per day for adults.',
      stepSuppHigh: 'From age 70, and in pregnancy or breastfeeding, total intake is 20 µg per day. Sciensano also cites a 20 µg daily supplement then.',
      stepMedical: 'If absorption is reduced, changing lifestyle alone is not enough. Have your vitamin D intake followed up by a doctor or pharmacist.',
      stepPreg: 'During pregnancy or breastfeeding, the Belgian recommendation is 20 µg (800 IU) per day. Use this alongside prenatal care.',
      stepKeep: 'Keep your current mix of time outdoors, food and supplements. A blood test remains the only way to know your status.',
      foodGood: 'Your diet already includes several sources, such as fatty fish, eggs or fortified foods.',
      foodGap: 'Your diet currently provides little vitamin D from fatty fish, eggs or fortified foods.',
      foodMixed: 'Part of your diet already helps. Add especially the sources you currently use little.',
      suppNoneNote: 'You are not taking a vitamin D supplement.',
      suppGoodNote: 'You take a relevant daily amount: {ug} µg ({iu} IU).',
      suppLowNote: 'Your supplement is irregular or provides relatively little: {ug} µg ({iu} IU) per day.',
      leadSunRisk: 'Sunlight weighs most in this result.',
      leadFoodRisk: 'Food weighs most in this result.',
      leadSuppRisk: 'Your supplement weighs most in this result.',
      leadPersonalRisk: 'Personal factors weigh most in this result.',
      leadSunHelp: 'Sunlight weighs most in your favour.',
      leadFoodHelp: 'Food weighs most in your favour.',
      leadSuppHelp: 'Your supplement weighs most in your favour.',
      sunStrong: 'A clear chance of production through the skin.',
      sunMid: 'You get outside, but the conditions limit production.',
      sunLow: 'Little useful UVB in your answers.',
      foodStrongLine: 'A clear contribution from fish, eggs or fortified foods.',
      foodMidLine: 'Part of your diet helps.',
      foodLowLine: 'Little vitamin D from food.',
      suppStrongLine: 'Your daily dose covers a relevant part.',
      suppMidLine: 'Irregular, or a lower amount.',
      suppLowLine: 'No relevant supplement reported.',
      personalNone: 'No extra age or absorption factor.',
      personalAge70: 'From age 70, vitamin D needs extra attention.',
      personalAge50: 'Age can reduce skin production somewhat.',
      personalAbs: 'Possible reduced absorption weighs extra.',
      personalPreg: 'Pregnancy or breastfeeding needs a higher intake.',
      personalBoth: 'Pregnancy or breastfeeding and possible reduced absorption both weigh extra.',
      factors: {
        periodLow: 'In this period there is little UVB in Belgium for vitamin D production.',
        periodShoulder: 'In this period the useful UVB window in Belgium is limited.',
        durationNone: 'You are almost never outdoors in daylight.',
        durationLow: 'Your daily time outdoors is short.',
        timeOff: 'You are mostly outside before 10:00 or after 17:00, when there is less UVB.',
        areaLow: 'Only the face and hands are exposed.',
        glass: 'Glass blocks almost all UVB, including a car window.',
        mixed: 'Part of your daylight comes through glass.',
        skinDark: 'Darker skin produces less vitamin D with the same sun exposure.',
        skinMedium: 'Your skin type may need somewhat more sun exposure.',
        fishNone: 'You do not eat fatty fish.',
        fishLow: 'You eat little fatty fish.',
        fishOne: 'You eat fatty fish about once a week.',
        eggsLow: 'You eat few or no eggs.',
        fortifiedNone: 'You use few or no vitamin-D-fortified foods.',
        suppNone: 'You do not take a vitamin D supplement.',
        suppLow: 'Your supplement provides relatively little vitamin D, or you take it irregularly.',
        age70: 'From age 70, vitamin D production in the skin decreases.',
        age50: 'Age can gradually reduce vitamin D production in the skin.',
        absorption: 'Possible reduced absorption can increase the chance of a low status.'
      },
      positives: {
        periodHigh: 'In this period Belgium offers more chance of vitamin D production from sunlight.',
        durationGood: 'You spend long enough outdoors for production to count.',
        timeGood: 'You are outside around the strongest UVB part of the day.',
        areaGood: 'A larger skin area is exposed than face and hands only.',
        direct: 'You get direct outdoor light, not only through glass.',
        skinLight: 'Your skin produces vitamin D relatively efficiently with UVB exposure.',
        plateau: 'Extra hours beyond about two hours a day add little extra production.',
        fish: 'You regularly eat fatty fish.',
        eggs: 'You regularly eat eggs.',
        fortified: 'You regularly use vitamin-D-fortified foods.',
        suppGood: 'You take a relevant amount of vitamin D.',
        noAbs: 'You reported no known absorption problems.'
      }
    }
  };

  var OPT = {
    nl: {
      period: { 'dec-jan': 'December–januari', 'feb-mar': 'Februari–maart', 'apr-may': 'April–mei', 'jun-aug': 'Juni–augustus', 'sep-oct': 'September–oktober', nov: 'November' },
      duration: { never: 'Bijna nooit', under15: 'Minder dan 15 min per dag', '15-30': '15–30 min per dag', '30-60': '30–60 min per dag', '1-2': '1–2 uur per dag', '2-4': '2–4 uur per dag', '4plus': 'Meer dan 4 uur per dag' },
      daytime: { before10: 'Voor 10:00', '10-12': '10:00–12:00', '12-15': '12:00–15:00', '15-17': '15:00–17:00', after17: 'Na 17:00', varies: 'Wisselt' },
      skinarea: { hands: 'Alleen gezicht en handen', forearms: 'Gezicht + onderarmen', arms: 'Gezicht + armen', legs: 'Armen + onderbenen', large: 'Groot deel van het lichaam' },
      exposure: { direct: 'Direct buiten', glass: 'Vaak achter glas / autoraam', mixed: 'Gemengd' },
      skin: { light: 'Licht', medium: 'Medium', dark: 'Donker' },
      fish: { '3plus': '3× of vaker per week', '2': '2× per week', '1': '1× per week', less1: 'Minder dan 1× per week', never: 'Nooit' },
      eggs: { daily: 'Dagelijks', '4-6': '4–6 per week', '1-3': '1–3 per week', rarely: 'Zelden/nooit' },
      fortified: { daily: 'Dagelijks', regular: 'Meerdere keren per week', weekly: 'Ongeveer 1× per week', rarely: 'Zelden', never: 'Nooit / weet ik niet' },
      mushrooms: { often: 'Regelmatig', sometimes: 'Soms', never: 'Zelden of nooit' },
      suppuse: { daily: 'Dagelijks', sometimes: 'Soms', none: 'Nee' },
      age: { '18-49': '18–49', '50-70': '50–70', '70plus': '70+' },
      absorption: { no: 'Nee', yes: 'Ja', unknown: 'Weet ik niet' },
      preg: { no: 'Nee', yes: 'Ja', na: 'Niet van toepassing' }
    },
    en: {
      period: { 'dec-jan': 'December–January', 'feb-mar': 'February–March', 'apr-may': 'April–May', 'jun-aug': 'June–August', 'sep-oct': 'September–October', nov: 'November' },
      duration: { never: 'Almost never', under15: 'Less than 15 min/day', '15-30': '15–30 min/day', '30-60': '30–60 min/day', '1-2': '1–2 hours/day', '2-4': '2–4 hours/day', '4plus': '4+ hours/day' },
      daytime: { before10: 'Before 10:00', '10-12': '10:00–12:00', '12-15': '12:00–15:00', '15-17': '15:00–17:00', after17: 'After 17:00', varies: 'Varies' },
      skinarea: { hands: 'Face/hands only', forearms: 'Face + forearms', arms: 'Face + arms', legs: 'Arms + lower legs', large: 'Large part of body' },
      exposure: { direct: 'Directly outdoors', glass: 'Often behind glass / car window', mixed: 'Mixed' },
      skin: { light: 'Light', medium: 'Medium', dark: 'Dark' },
      fish: { '3plus': '3× or more per week', '2': '2× per week', '1': '1× per week', less1: 'Less than 1× per week', never: 'Never' },
      eggs: { daily: 'Daily', '4-6': '4–6 per week', '1-3': '1–3 per week', rarely: 'Rarely/never' },
      fortified: { daily: 'Daily', regular: 'Several times a week', weekly: 'About once a week', rarely: 'Rarely', never: 'Never / not sure' },
      mushrooms: { often: 'Regularly', sometimes: 'Sometimes', never: 'Rarely or never' },
      suppuse: { daily: 'Daily', sometimes: 'Sometimes', none: 'No' },
      age: { '18-49': '18–49', '50-70': '50–70', '70plus': '70+' },
      absorption: { no: 'No', yes: 'Yes', unknown: 'Not sure' },
      preg: { no: 'No', yes: 'Yes', na: 'Not applicable' }
    }
  };

  function round1(n) {
    return Math.round(n * 10) / 10;
  }

  function init(root) {
    if (!root || root.dataset.mjVitaminDInit === '1') return;
    root.dataset.mjVitaminDInit = '1';
    var lang = root.dataset.defaultLang === 'en' ? 'en' : 'nl';

    function text(key) {
      return COPY[lang][key] || '';
    }

    function value(name) {
      var el = root.querySelector('[data-mj-input="' + name + '"]:checked');
      return el ? el.value : '';
    }

    function doseUg() {
      if (value('suppuse') === 'none') return 0;
      var raw = parseFloat((root.querySelector('[data-mj-input="dose"]') || {}).value || '0');
      if (!isFinite(raw) || raw < 0) raw = 0;
      var unit = (root.querySelector('[data-mj-input="doseunit"]') || {}).value || 'ug';
      return unit === 'iu' ? raw / UG_PER_IU : raw;
    }

    function applyCopy() {
      root.querySelectorAll('[data-mj-copy]').forEach(function (node) {
        var key = node.getAttribute('data-mj-copy');
        if (COPY[lang][key]) node.textContent = COPY[lang][key];
      });
      root.querySelectorAll('[data-mj-option]').forEach(function (node) {
        var group = node.getAttribute('data-mj-option');
        var option = node.getAttribute('data-mj-option-value');
        if (OPT[lang][group] && OPT[lang][group][option]) node.textContent = OPT[lang][group][option];
      });
      root.querySelectorAll('[data-mj-lang]').forEach(function (button) {
        var active = button.getAttribute('data-mj-lang') === lang;
        button.classList.toggle('mj-app__lang-btn--active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var unit = root.querySelector('[data-mj-input="doseunit"]');
      if (unit) unit.setAttribute('aria-label', lang === 'en' ? 'Unit' : 'Eenheid');
      var closer = root.querySelector('[data-mj-close-label]');
      if (closer) closer.setAttribute('aria-label', text('closeLabel'));
    }

    function push(list, bucket, key, weight) {
      var line = COPY[lang][bucket][key];
      if (line) list.push({ text: line, weight: weight || 1 });
    }

    var SUN_MAX = 52;
    var FOOD_MAX = 40;
    var SUPP_MAX = 40;
    var SEASON = { 'dec-jan': 0.05, nov: 0.18, 'feb-mar': 0.32, 'sep-oct': 0.5, 'apr-may': 0.78, 'jun-aug': 1 };
    var DURATION = { never: 0, under15: 0.22, '15-30': 0.5, '30-60': 0.78, '1-2': 0.94, '2-4': 1, '4plus': 1 };
    var TIME = { before10: 0.28, '10-12': 0.72, '12-15': 1, '15-17': 0.58, after17: 0.16, varies: 0.62 };
    var AREA = { hands: 0.28, forearms: 0.52, arms: 0.72, legs: 0.9, large: 1 };
    var TYPE = { direct: 1, mixed: 0.62, glass: 0.12 };
    var SKIN = { light: 1, medium: 0.72, dark: 0.42 };
    var AGE_SUN = { '18-49': 1, '50-70': 0.85, '70plus': 0.7 };

    function ratioBand(supply, max) {
      var ratio = max ? supply / max : 0;
      if (ratio >= 0.62) return 'strong';
      if (ratio >= 0.32) return 'mid';
      return 'low';
    }

    function score() {
      var risks = [];
      var positives = [];
      var period = value('period');
      var duration = value('duration');
      var daytime = value('daytime');
      var skinarea = value('skinarea');
      var exposure = value('exposure');
      var skin = value('skin');
      var fish = value('fish');
      var eggs = value('eggs');
      var fortified = value('fortified');
      var mushrooms = value('mushrooms') || 'never';
      var suppuse = value('suppuse');
      var age = value('age');
      var absorption = value('absorption');
      var preg = value('preg');
      var ug = doseUg();
      var durationFactor = DURATION[duration] || 0;
      var timeFactor = durationFactor === 0 ? 0 : (TIME[daytime] || 0);
      var raw = (SEASON[period] || 0) * durationFactor * timeFactor * (AREA[skinarea] || 0) * (TYPE[exposure] || 0) * (SKIN[skin] || 0) * (AGE_SUN[age] || 1);
      if (raw > 1) raw = 1;
      var sunSupply = raw * SUN_MAX;
      var fishPts = { '3plus': 20, '2': 15, '1': 8, less1: 3, never: 0 }[fish] || 0;
      var eggPts = { daily: 5, '4-6': 3, '1-3': 1, rarely: 0 }[eggs] || 0;
      var fortPts = { daily: 12, regular: 8, weekly: 4, rarely: 1, never: 0 }[fortified] || 0;
      var mushroomPts = { often: 3, sometimes: 1, never: 0 }[mushrooms] || 0;
      var foodSupply = Math.min(FOOD_MAX, fishPts + eggPts + fortPts + mushroomPts);
      var suppSupply = 0;
      if (suppuse !== 'none' && ug > 0) {
        suppSupply = ug >= 20 ? 40 : ug >= 15 ? 34 : ug >= 10 ? 28 : ug >= 5 ? 14 : 5;
        if (suppuse === 'sometimes') suppSupply = Math.round(suppSupply * 0.5);
        suppSupply = Math.min(SUPP_MAX, suppSupply);
      }
      var abs = absorption === 'yes' ? 0.45 : absorption === 'unknown' ? 0.8 : 1;
      var foodEffective = foodSupply * abs;
      var suppEffective = suppSupply * abs;
      var need = 100;
      if (age === '70plus') need += 16;
      else if (age === '50-70') need += 8;
      if (absorption === 'yes') need += 18;
      if (preg === 'yes') need += 8;
      var gap = need - (sunSupply + foodEffective + suppEffective);
      if (absorption === 'yes' && gap < 42) gap = 42;
      var level = gap <= 40 ? 'riskLow' : gap <= 84 ? 'riskMid' : 'riskHigh';
      var sunRatio = sunSupply / SUN_MAX;
      var lowSeason = period === 'dec-jan' || period === 'nov';
      var shoulder = period === 'feb-mar' || period === 'sep-oct';

      if (lowSeason) push(risks, 'factors', 'periodLow', 9);
      else if (shoulder && sunRatio < 0.4) push(risks, 'factors', 'periodShoulder', 6);
      if (duration === 'never') push(risks, 'factors', 'durationNone', 9);
      else if (duration === 'under15') push(risks, 'factors', 'durationLow', 7);
      if ((daytime === 'before10' || daytime === 'after17') && duration !== 'never') push(risks, 'factors', 'timeOff', 5);
      if (skinarea === 'hands' && duration !== 'never') push(risks, 'factors', 'areaLow', 6);
      if (exposure === 'glass') push(risks, 'factors', 'glass', 8);
      else if (exposure === 'mixed') push(risks, 'factors', 'mixed', 4);
      if (skin === 'dark' && sunRatio < 0.55) push(risks, 'factors', 'skinDark', 7);
      else if (skin === 'medium' && sunRatio < 0.45) push(risks, 'factors', 'skinMedium', 3);
      if (fish === 'never') push(risks, 'factors', 'fishNone', 6);
      else if (fish === 'less1') push(risks, 'factors', 'fishLow', 4);
      else if (fish === '1') push(risks, 'factors', 'fishOne', 2);
      if (eggs === 'rarely') push(risks, 'factors', 'eggsLow', 2);
      if (fortified === 'never' || fortified === 'rarely') push(risks, 'factors', 'fortifiedNone', 4);
      if (suppuse === 'none' || ug < 5) push(risks, 'factors', 'suppNone', 7);
      else if (!(suppuse === 'daily' && ug >= 10)) push(risks, 'factors', 'suppLow', 4);
      if (age === '70plus') push(risks, 'factors', 'age70', 8);
      else if (age === '50-70') push(risks, 'factors', 'age50', 3);
      if (absorption === 'yes') push(risks, 'factors', 'absorption', 10);

      if ((period === 'jun-aug' || period === 'apr-may') && duration !== 'never') push(positives, 'positives', 'periodHigh', 6);
      if (sunRatio >= 0.35 && duration !== 'never' && duration !== 'under15') push(positives, 'positives', 'durationGood', 5);
      if ((daytime === '12-15' || daytime === '10-12') && duration !== 'never' && sunRatio >= 0.3) push(positives, 'positives', 'timeGood', 4);
      if ((skinarea === 'legs' || skinarea === 'large' || skinarea === 'arms') && duration !== 'never') push(positives, 'positives', 'areaGood', 4);
      if (exposure === 'direct' && sunRatio >= 0.35) push(positives, 'positives', 'direct', 3);
      if (skin === 'light' && sunRatio >= 0.35) push(positives, 'positives', 'skinLight', 3);
      if (duration === '2-4' || duration === '4plus') push(positives, 'positives', 'plateau', 2);
      if (fish === '3plus' || fish === '2') push(positives, 'positives', 'fish', fish === '3plus' ? 6 : 5);
      if (eggs === 'daily' || eggs === '4-6') push(positives, 'positives', 'eggs', 2);
      if (fortified === 'daily' || fortified === 'regular') push(positives, 'positives', 'fortified', 5);
      if (suppuse === 'daily' && ug >= 10) push(positives, 'positives', 'suppGood', 6);
      if (absorption === 'no') push(positives, 'positives', 'noAbs', 1);

      var helps = [
        { id: 'sun', v: sunSupply },
        { id: 'food', v: foodEffective },
        { id: 'supp', v: suppEffective }
      ];
      var misses = [
        { id: 'sun', v: SUN_MAX - sunSupply },
        { id: 'food', v: FOOD_MAX - foodEffective },
        { id: 'supp', v: SUPP_MAX - suppEffective },
        { id: 'personal', v: Math.max(0, need - 100) }
      ];
      function top(list) {
        return list.slice().sort(function (a, b) { return b.v - a.v; })[0];
      }
      var bestHelp = top(helps);
      var bestMiss = top(misses);
      var lead = absorption === 'yes'
        ? { id: 'personal', tone: 'risk' }
        : (level === 'riskLow' && bestHelp.v >= 8) || (level !== 'riskHigh' && bestHelp.v >= 20)
          ? { id: bestHelp.id, tone: 'help' }
          : { id: bestMiss.id, tone: 'risk' };
      var leadKey = 'lead' + lead.id.charAt(0).toUpperCase() + lead.id.slice(1) + (lead.tone === 'help' ? 'Help' : 'Risk');
      var sunBand = ratioBand(sunSupply, SUN_MAX);
      var foodBand = ratioBand(foodSupply, FOOD_MAX);
      var suppBand = ratioBand(suppSupply, SUPP_MAX);
      var personalLine = absorption === 'yes' && preg === 'yes' ? 'personalBoth'
        : absorption === 'yes' ? 'personalAbs'
        : preg === 'yes' ? 'personalPreg'
        : age === '70plus' ? 'personalAge70'
        : age === '50-70' ? 'personalAge50'
        : 'personalNone';

      function lines(list) {
        return list.slice().sort(function (a, b) { return b.weight - a.weight; }).map(function (item) { return item.text; });
      }

      return {
        level: level,
        risks: lines(risks),
        positives: lines(positives),
        leadKey: leadKey,
        leadId: lead.id,
        components: [
          text(sunBand === 'strong' ? 'sunStrong' : sunBand === 'mid' ? 'sunMid' : 'sunLow'),
          text(foodBand === 'strong' ? 'foodStrongLine' : foodBand === 'mid' ? 'foodMidLine' : 'foodLowLine'),
          text(suppBand === 'strong' ? 'suppStrongLine' : suppBand === 'mid' ? 'suppMidLine' : 'suppLowLine'),
          text(personalLine)
        ],
        period: period,
        duration: duration,
        daytime: daytime,
        skinarea: skinarea,
        exposure: exposure,
        sunRatio: sunRatio,
        skin: skin,
        fish: fish,
        eggs: eggs,
        fortified: fortified,
        mushrooms: mushrooms,
        age: age,
        absorption: absorption,
        preg: preg,
        suppuse: suppuse,
        ug: ug
      };
    }

    function renderList(el, items, empty) {
      el.replaceChildren();
      (items.length ? items : [empty]).forEach(function (line) {
        var li = document.createElement('li');
        li.textContent = line;
        el.appendChild(li);
      });
    }

    function syncDose() {
      var wrap = root.querySelector('[data-mj-supp-dose]');
      if (wrap) wrap.hidden = value('suppuse') === 'none';
    }

    function joinBits(parts) {
      if (parts.length < 2) return parts[0] || '';
      var last = parts[parts.length - 1];
      return parts.slice(0, -1).join(', ') + (lang === 'nl' ? ' en ' : ' and ') + last;
    }

    function summaryText(result, level) {
      var lead = text(level === 'riskLow' ? 'summaryLow' : level === 'riskMid' ? 'summaryMid' : 'summaryHigh');
      if (level === 'riskLow') return lead;
      var bits = [];
      var lowSun = result.sunRatio < 0.4;
      var littleTime = result.duration === 'never' || result.duration === 'under15';
      if (result.period === 'dec-jan' || result.period === 'nov') bits.push(text('bitSeasonLow'));
      else if ((result.period === 'feb-mar' || result.period === 'sep-oct') && lowSun) bits.push(text('bitSeasonLimited'));
      if (result.skin === 'dark' && lowSun) bits.push(text('bitDarkSun'));
      else if (littleTime) bits.push(text('bitOutside'));
      if (result.exposure === 'glass') bits.push(text('bitGlass'));
      if (result.skinarea === 'hands' && result.duration !== 'never') bits.push(text('bitHands'));
      if (result.fish === 'never' || result.fish === 'less1') bits.push(text('bitFish'));
      if (result.suppuse === 'none') bits.push(text('bitSupp'));
      if (result.age === '70plus') bits.push(text('bitAge'));
      bits = bits.slice(0, 3);
      if (!bits.length) return lead;
      var because = bits.length === 1 ? text('summaryBecauseOne') : text('summaryBecause');
      return lead + ' ' + because.replace('{bits}', joinBits(bits));
    }

    function nextSteps(result) {
      var steps = [];
      var lowSeason = result.period === 'dec-jan' || result.period === 'nov' || result.period === 'feb-mar';
      var sunLow = result.sunRatio < 0.35;
      var higherNeed = result.age === '70plus' || result.preg === 'yes';
      if (sunLow && lowSeason) steps.push(text('stepSunCold'));
      else if (sunLow) steps.push(text('stepSunWarm'));
      if (result.exposure === 'glass' || result.exposure === 'mixed') steps.push(text('stepGlass'));
      if (result.skinarea === 'hands') steps.push(text('stepArea'));
      if (result.fish === 'never' || result.fish === 'less1') steps.push(text('stepFish'));
      if (result.eggs === 'rarely') steps.push(text('stepEggs'));
      if (result.fortified === 'never' || result.fortified === 'rarely') steps.push(text('stepFortified'));
      if (result.suppuse === 'none' || result.ug < 10) steps.push(text(higherNeed ? 'stepSuppHigh' : 'stepSupp'));
      if (result.absorption === 'yes') steps.push(text('stepMedical'));
      if (result.preg === 'yes') steps.push(text('stepPreg'));
      if (!steps.length) steps.push(text('stepKeep'));
      return steps.slice(0, 3);
    }

    function foodNote(result) {
      var goodFish = result.fish === '3plus' || result.fish === '2';
      var goodEggs = result.eggs === 'daily' || result.eggs === '4-6';
      var goodFort = result.fortified === 'daily' || result.fortified === 'regular';
      var gaps = (result.fish === 'never' || result.fish === 'less1') && result.eggs === 'rarely' && (result.fortified === 'never' || result.fortified === 'rarely');
      if (gaps) return text('foodGap');
      if (goodFish && goodEggs && goodFort) return text('foodGood');
      return text('foodMixed');
    }

    function supplementNote(result) {
      if (result.suppuse === 'none') return text('suppNoneNote');
      var ug = round1(result.ug);
      var iu = Math.round(ug * UG_PER_IU);
      var key = result.suppuse === 'daily' && ug >= 10 ? 'suppGoodNote' : 'suppLowNote';
      return text(key).replace('{ug}', String(ug)).replace('{iu}', String(iu));
    }

    var stepIndex = 0;
    var stepNodes = root.querySelectorAll('[data-mj-step]');
    var stepKeys = ['step1', 'step2', 'step3', 'step4'];

    function showStep(index) {
      stepIndex = Math.max(0, Math.min(stepNodes.length - 1, index));
      stepNodes.forEach(function (node, i) {
        node.hidden = i !== stepIndex;
      });
      var name = text(stepKeys[stepIndex] + 'Title');
      var progress = text('progress').replace('{n}', String(stepIndex + 1)).replace('{name}', name);
      var progressNode = root.querySelector('[data-mj-progress]');
      var kicker = root.querySelector('[data-mj-guide-kicker]');
      if (progressNode) progressNode.textContent = progress;
      if (kicker) kicker.textContent = progress;
      var body = root.querySelector('[data-mj-guide-text]');
      if (body) body.textContent = text(stepKeys[stepIndex] + 'Text');
      root.querySelectorAll('[data-mj-step-jump]').forEach(function (btn) {
        var on = Number(btn.getAttribute('data-mj-step-jump')) === stepIndex;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-current', on ? 'step' : 'false');
      });
      root.querySelectorAll('[data-mj-pillar]').forEach(function (item) {
        item.classList.toggle('is-active', Number(item.getAttribute('data-mj-pillar')) === stepIndex);
      });
      var bar = root.querySelector('[data-mj-progress-bar]');
      if (bar) bar.style.width = ((stepIndex + 1) * 25) + '%';
      var prev = root.querySelector('[data-mj-prev]');
      var next = root.querySelector('[data-mj-next]');
      var analyse = root.querySelector('[data-mj-action="calculate"]');
      if (prev) prev.hidden = stepIndex === 0;
      if (next) next.hidden = stepIndex === stepNodes.length - 1;
      if (analyse) analyse.hidden = stepIndex !== stepNodes.length - 1;
    }

    function focusableIn(container) {
      return Array.prototype.filter.call(
        container.querySelectorAll('button, a[href], input, select, textarea'),
        function (el) {
          return !el.disabled && !el.hidden && el.offsetParent !== null;
        }
      );
    }

    function openModal() {
      var modal = root.querySelector('[data-mj-modal]');
      modal.hidden = false;
      document.documentElement.classList.add('mj-vd-modal-open');
      var closer = modal.querySelector('.mj-vd-modal__x');
      if (closer) closer.focus();
    }

    function closeModal(restoreAnalyse) {
      var modal = root.querySelector('[data-mj-modal]');
      modal.hidden = true;
      document.documentElement.classList.remove('mj-vd-modal-open');
      if (restoreAnalyse !== false) {
        var analyse = root.querySelector('[data-mj-action="calculate"]');
        if (analyse && !analyse.hidden) analyse.focus();
      }
    }

    function calculate(open) {
      syncDose();
      var result = score();
      var level = result.level;
      var badge = root.querySelector('[data-mj-risk-badge]');
      badge.textContent = text(level);
      badge.dataset.level = level;
      root.querySelector('[data-mj-summary]').textContent = summaryText(result, level);
      root.querySelector('[data-mj-lead]').textContent = text(result.leadKey);
      ['sun', 'food', 'supp', 'personal'].forEach(function (id, index) {
        var row = root.querySelector('[data-mj-weight="' + id + '"]');
        if (!row) return;
        row.classList.toggle('is-lead', id === result.leadId);
        var note = row.querySelector('[data-mj-weight-note]');
        if (note) note.textContent = result.components[index] || '';
      });
      renderList(root.querySelector('[data-mj-risk-list]'), result.risks.slice(0, 4), text('emptyRisk'));
      renderList(root.querySelector('[data-mj-positive-list]'), result.positives.slice(0, 3), text('emptyPositive'));
      renderList(root.querySelector('[data-mj-next-list]'), nextSteps(result), text('stepKeep'));
      root.querySelector('[data-mj-food-note]').textContent = foodNote(result);
      root.querySelector('[data-mj-supp-note]').textContent = supplementNote(result);
      root.querySelector('[data-mj-intake-note]').textContent = result.preg === 'yes'
        ? text('intakePreg')
        : result.age === '70plus' ? text('intake70') : text('intakeAdult');

      var special = root.querySelector('[data-mj-special-note]');
      var specialText = root.querySelector('[data-mj-special-text]');
      if (result.absorption === 'yes' || result.preg === 'yes') {
        special.hidden = false;
        specialText.textContent = result.absorption === 'yes' && result.preg === 'yes'
          ? text('specialBoth')
          : result.absorption === 'yes' ? text('specialAbs') : text('specialPreg');
      } else {
        special.hidden = true;
        specialText.textContent = '';
      }

      if (open) openModal();
    }

    root.querySelectorAll('[data-mj-input="suppuse"]').forEach(function (input) {
      input.addEventListener('change', syncDose);
    });
    root.querySelectorAll('[data-mj-lang]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = button.getAttribute('data-mj-lang');
        if (next !== 'nl' && next !== 'en') return;
        lang = next;
        applyCopy();
        showStep(stepIndex);
        if (!root.querySelector('[data-mj-modal]').hidden) calculate(true);
      });
    });
    var button = root.querySelector('[data-mj-action="calculate"]');
    if (button) button.addEventListener('click', function () { calculate(true); });
    var prevButton = root.querySelector('[data-mj-prev]');
    var nextButton = root.querySelector('[data-mj-next]');
    if (prevButton) prevButton.addEventListener('click', function () { showStep(stepIndex - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { showStep(stepIndex + 1); });
    root.querySelectorAll('[data-mj-step-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(Number(btn.getAttribute('data-mj-step-jump')));
      });
    });
    root.querySelectorAll('[data-mj-modal-close]').forEach(function (node) {
      node.addEventListener('click', function () { closeModal(true); });
    });
    var refill = root.querySelector('[data-mj-refill]');
    if (refill) {
      refill.addEventListener('click', function () {
        closeModal(false);
        showStep(0);
        var form = root.querySelector('.mj-app__panel--inputs');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    document.addEventListener('keydown', function (event) {
      var modal = root.querySelector('[data-mj-modal]');
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var dialog = modal.querySelector('.mj-vd-modal__dialog');
      var items = focusableIn(dialog);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    applyCopy();
    (function selectCurrentPeriod() {
      var month = new Date().getMonth() + 1;
      var key = 'sep-oct';
      if (month === 12 || month === 1) key = 'dec-jan';
      else if (month === 2 || month === 3) key = 'feb-mar';
      else if (month === 4 || month === 5) key = 'apr-may';
      else if (month >= 6 && month <= 8) key = 'jun-aug';
      else if (month === 11) key = 'nov';
      var input = root.querySelector('[data-mj-input="period"][value="' + key + '"]');
      if (input) input.checked = true;
    })();
    showStep(0);
    syncDose();
  }

  document.querySelectorAll('[data-mj-vitamin-d-app]').forEach(init);
})();
